const maxAngleDifferenceRadians = (3 * Math.PI) / 180;

export const Alignment = {
	maxAngleDifferenceRadians,
	maxAngleCrossProduct: Math.sin(maxAngleDifferenceRadians),
} as const;
